import React from 'react';

interface BadgePillProps {
  count?: any;
  active?: any;
}

function BadgePill({ count = 0, active = false }: BadgePillProps) {
  const baseStyle: any = {
    display: 'flex',
    padding: '2px 10px',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '10px',
    borderRadius: '9999px',
    border: '1px solid rgba(255,255,255,0.00)',
    fontSize: '12px',
  };

  const activeStyle: any = {
    background: '#0F172A',
    color: 'white',
  };

  const inactiveStyle: any = {
    background: '#F1F5F9',
    color: '#0F172A',
  };

  const style: any = { ...baseStyle, ...(active ? activeStyle : inactiveStyle) };

  return <span style={style}>{count}</span>;
}

export default BadgePill;
